module.exports = __webpack_public_path__ + "img/icon.462f6cad.jpg";